import React from "react";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import MuiSwitch from "@material-ui/core/Switch";
import { Controller } from "react-hook-form";
import { FormGroup, styled, Typography } from "@material-ui/core";
import clsx from "clsx";

const CustomSwitch = styled(MuiSwitch)(({ theme }) => ({
  "& .MuiSwitch-switchBase": {
    color: theme.palette.common.white,
    "&.Mui-checked": {
      color: theme.palette.common.white,
      "& + .MuiSwitch-track": {
        backgroundColor: "#022375 !important",
        opacity: 1,
        border: "none",
      },
      "& .MuiSwitch-thumb": {
        boxShadow: "0 2px 4px 0 rgb(0 35 117 / 16%)",
        backgroundImage: "none",
        backgroundColor: theme.palette.common.white,
      },
    },
  },
  "& .MuiSwitch-thumb": {
    backgroundImage: "none !important",
    backgroundColor: "rgba(2, 35, 117, 0.3)",
  },
  "& .MuiSwitch-track": {
    opacity: 1,
    backgroundColor: theme.palette.common.white,
    border: "2px solid #022375",
  },
}));

function FormSwitch({ name, control, label, disableMargin, ...props }) {
  return (
    <FormGroup
      className={clsx({
        formGroup: disableMargin,
      })}
    >
      <Controller
        name={name}
        control={control}
        render={({ field: { value, onChange, ...field } }) => (
          <FormControlLabel
            {...props}
            style={{ marginRight: 0 }}
            control={
              <CustomSwitch
                {...field}
                onChange={(event) => {
                  onChange(event.target.checked);
                }}
                checked={!!value}
              />
            }
            label={
              <Typography variant="body1" style={{ color: "#474747", marginLeft: "10px" }}>
                {label}
              </Typography>
            }
          />
        )}
      />
    </FormGroup>
  );
}

export default FormSwitch;
